import { render, staticRenderFns } from "./List-estoque.vue?vue&type=template&id=8f41aeb2&"
import script from "./List-estoque.vue?vue&type=script&lang=js&"
export * from "./List-estoque.vue?vue&type=script&lang=js&"
import style0 from "./List-estoque.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports